import { createApiRef } from '@backstage/core-plugin-api';
import { ComponentHealthDataResponse } from '../types/CicdScan';

export const wizApiRef = createApiRef<WizAPI>({
  id: 'plugin.wiz.service',
});

export interface WizAPI {
  getCicdScans(appName: string): Promise<ComponentHealthDataResponse>;
}
